import {Col} from "@cdx/ds";

const PublicProjectLayout = ({children}) => (
  <Col
    absolute
    left={0}
    top={0}
    width="100%"
    minHeight="100%"
    data-cdx-context="PublicProject"
    colorTheme="gray550"
  >
    {children}
  </Col>
);

export default PublicProjectLayout;
